import { Button, Card, InputNumber, Modal, notification, Select } from "antd"
import Form from "antd/es/form/Form"
import Input from "antd/es/input/Input"
import Title from "antd/es/typography/Title"
import { CreateToolHistory, GetAccountsBySize, GetAllAccounts, GetAllRetreats, GetAllTools, GetRetreatsBySize, GetToolsBySize, } from "../../../api/AdminService"
import { useNavigate } from "react-router-dom"
import { PlusOutlined, ArrowLeftOutlined, TruckFilled } from '@ant-design/icons';
import { Option } from "antd/es/mentions"
import { useEffect, useState } from "react"
const AdminAddToolHistory = ({ open, onClose, onSuccess }) => {

    const navigate = useNavigate()
    const [RetreatData, setRetreatData] = useState([]);
    const [UserData, setUserData] = useState([]);
    const [ToolData, setToolData] = useState([]);
    const [loading, setLoading] = useState(false);

    const getRetreats = () => {
        try {
            GetRetreatsBySize(1000).then(res => {
                if (res.status === 200) {
                    console.log(res.data.data)
                    setRetreatData(res.data.data)
                }
            })
        } catch (err) {
            console.log(err)
        }
    }

    const getUsers = () => {
        try {
            GetAccountsBySize(1000).then(res => {
                if (res.status === 200) {
                    console.log(res.data.data)
                    const nonPractitioners = res.data.data.filter(user => user.role !== 'Practitioner');
                    setUserData(nonPractitioners);
                }
            })
        } catch (err) {
            console.log(err)
        }
    }

    const getTools = () => {
        try {
            GetToolsBySize(1000).then(res => {
                if (res.status === 200) {
                    console.log(res.data.data)
                    setToolData(res.data.data)
                }
            })
        } catch (err) {
            console.log(err)
        }
    }

    useEffect(() => {
        getRetreats();
        getUsers();
        getTools();
    }, []);

    const onFinish = (values) => {
        setLoading(true);
        CreateToolHistory(values.retreatId, values.borrowerId
            // , values.toolId, values.numOfTool
        ).then((res) => {
            console.log(res);
            notification.success({
                message: "Create Successfully"
            });
            setLoading(false);
            onSuccess();
            onClose();
            // setTimeout(navigate('/Admin/ToolHistory'), 2000);

        }).catch((err) => {
            console.log(err);
            notification.error({
                message: err.response?.data?.message || err.response?.data?.messages               
            });
            setLoading(false)
        });

    }


    return (
        // <div style={{ minHeight: '96.5vh', Width: '100%' }}
        // >
        //     <Button
        //         icon={<ArrowLeftOutlined />}
        //         onClick={() => navigate(-1)}
        //         style={{ marginBottom: 16 }}
        //     >
        //         Go Back
        //     </Button>
        //     <div style={{ maxWidth: 600, margin: 'auto', padding: '24' }}>
        //         <Title level={2} style={{ textAlign: 'center', marginBottom: '24' }}>
        //             Create Tool History
        //         </Title>
        <Modal
            open={open}
            title="Borrow Information"
            onCancel={onClose}
            footer={[]}
        >
            <Form
                onFinish={onFinish}
                name="wrap"
                labelAlign="left"
                labelWrap
                labelCol={{ flex: '150px' }}
            >
                {/* <Card title="Requirement Information" style={{ border: '1px solid #d9d9d9', borderRadius: '4px', marginBottom: 20 }}> */}
                    <Form.Item name={"retreatId"} label="Retreat" rules={[{ required: true, message: 'Requiring Retreat' }]}>
                        <Select
                            placeholder="Choose Retreat"
                        >
                            {RetreatData.map((item) => (
                                <Option key={item.id} value={item.id}>
                                    {item.name}
                                </Option>
                            ))}

                        </Select>
                    </Form.Item>
                    <Form.Item name={"borrowerId"} label="Borrower" rules={[{ required: true, message: 'Requiring Borrower ' }]}>
                        <Select
                            placeholder="Choose Borrower"
                        >
                            {UserData.map((item) => (
                                <Option key={item.id} value={item.id}>
                                    {item.firstName} {item.lastName} | {item.role}
                                </Option>
                            ))}

                        </Select>
                    </Form.Item>
                    {/* <Form.Item name={"toolId"} label=" Tool" rules={[{ required: true, message: 'Requiring  Tool' }]}>
                        <Select
                            placeholder="Choose Tool"
                        >
                            {ToolData.map((item) => (
                                <Option key={item.id} value={item.id}>
                                    {item.name}
                                </Option>
                            ))}

                        </Select>
                    </Form.Item>
                    <Form.Item name={"numOfTool"} label="Total Tool" rules={[{ required: true, message: 'Requiring Total Tool' }]}>
                        <InputNumber min={1} style={{ width: '100%' }}
                            placeholder="Input Total Tool"
                        />
                    </Form.Item> */}
                    <Form.Item >
                        <Button block type="primary" htmlType="submit" loading={loading}>
                            {loading ? "Loading" : "Save"}
                        </Button>
                    </Form.Item>
                {/* </Card> */}
            </Form>
        </Modal>
        //     </div>
        // </div>

    )

}
export default AdminAddToolHistory
